import { Injectable } from "@angular/core";

@Injectable()
export class LoggerService {

    public log(msg: any, severity?: any): boolean {
        console.log(msg);

        return true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/logger.service.ts